class WaitingRoom {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
        }
    }
    // mark ***
    fetch(options = {}){
        return this.client.get(`/waiting-room`, options)
    }
}

export default WaitingRoom


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/waitingRoom.js